import { render, staticRenderFns } from "./bookOrderDetail.vue?vue&type=template&id=4238ee60&scoped=true"
import script from "./bookOrderDetail.vue?vue&type=script&lang=js"
export * from "./bookOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./bookOrderDetail.vue?vue&type=style&index=0&id=4238ee60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4238ee60",
  null
  
)

export default component.exports